export default "__VITE_ASSET__CPuAoCkv__ 1920w";